import { GUI } from "dat.gui";
import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/tema8/GLB_VidrioRoto.glb";
import gsap from "gsap";

export class BreakPoint extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);

	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.VidrioRoto = gltf.scene.getObjectByName("VidrioRoto", true);
			this.VidrioRoto.material.emissive.set("#5E5E5E");

		});
	}

	onAnimationMovePosition(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.position,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onAnimationMoveRotation(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.rotation,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	clearAnimation() {
		if (this.animationEmisive) {
			this.animationEmisive.kill()
			this.animationEmisive = null
		}
		this.VidrioRoto.material.emissiveIntensity = 1
	}

	onAnimateEmissive() {
		this.clearAnimation()

		this.animationEmisive = gsap.to(this.VidrioRoto.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers(limit = 10) {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("break");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador
			.addColor({ emissive: this.VidrioRoto.material.emissive.getHex() }, "emissive")
			.name("Emissive")
			.onChange((value) => {
				this.VidrioRoto.material.emissive.set(value);
			});

		folderMostrador
			.addColor({ color: this.VidrioRoto.material.color.getHex() }, "color")
			.name("Color")
			.onChange((value) => {
				this.VidrioRoto.material.color.set(value);
			});

		folderMostrador.add(this, "visible").name("Visible");
	}
}
